import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
import { PtInput } from '../../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import $ from 'jquery';
import config from '../../../../config';

export default class Strength extends Component
{
    constructor(props) {
        super(props);
        this.state = this.props.strengthModel.pavementcondition;
    }

    getStrength = () => {
        if (this.props.strengthModel.route.id) {
            
            $.ajax({
                type: 'GET',
                url: `${config.server}\\getstrengthdata\\${this.props.strengthModel.route.id}`,
                contentType: 'application/json',
                success: (data) => {
                    this.setState({
                        SN: data.SN,
                        GE: data.GE,
                        ResMod: data.ResMod
                    });
                },
            });
        }
    }

    componentDidMount() {
        this.getStrength();
    }

    render() {
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>
                    <PtInput label="SN" value={this.state.SN === null ? "N.A" : Math.round(this.state.SN*100)/100} disabled name="SN" />

                    <PtInput label="GE" value={this.state.GE === null ? "N.A" : Math.round(this.state.GE*100)/100} disabled name="GE" />

                    <PtInput label="Resilient Modulus" value={this.state.ResMod === null ? "N.A" : this.state.ResMod} disabled  name="ResMod" />
                </ScrollArea>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-segment/forecasting/strength.js